import type {BusinessFeeNegotiation} from '@afriex/core/domain/types';

import {Badge} from '@/components';

import {getStatusLabel} from './negotiationFormat';
import {negotiationStatusColorScheme} from './negotiationStatus';

/** Whose move it is on an open request, or how a closed one ended. */
export const NegotiationStatusBadge = ({
  negotiation,
}: {
  negotiation: BusinessFeeNegotiation;
}) => (
  <Badge
    colorScheme={negotiationStatusColorScheme(negotiation.status)}
    className="normal-case"
  >
    {getStatusLabel(negotiation)}
  </Badge>
);

/** Whether a corridor's price moved in the standing round or is agreed. */
export const LineChangeBadge = ({isChanged}: {isChanged: boolean}) => (
  <Badge
    colorScheme={isChanged ? 'pending' : 'successful'}
    className="normal-case"
  >
    {isChanged ? 'Changed' : 'Agreed'}
  </Badge>
);

/** What happened to a corridor once the negotiation closed. */
export const LineOutcomeBadge = ({isApplied}: {isApplied: boolean}) => (
  <Badge
    colorScheme={isApplied ? 'successful' : 'gray'}
    className="normal-case"
  >
    {isApplied ? 'Applied' : 'Not applied'}
  </Badge>
);
